/**
 * Showcase Configurations Index
 * All demo showcase configurations exported from here
 */
export { overviewShowcase } from "./overview";
export { technicalShowcase } from "./technical";
export { tradingShowcase } from "./trading";
export { comparisonShowcase } from "./comparison";
export { customShowcase } from "./custom";
// All showcases registry
import { overviewShowcase } from "./overview";
import { technicalShowcase } from "./technical";
import { tradingShowcase } from "./trading";
import { comparisonShowcase } from "./comparison";
import { customShowcase } from "./custom";
export const ALL_SHOWCASES = [
    overviewShowcase,
    technicalShowcase,
    tradingShowcase,
    comparisonShowcase,
    customShowcase,
];
export function getShowcase(name) {
    return ALL_SHOWCASES.find((s) => s.name === name) ?? overviewShowcase;
}
export function getShowcaseNames() {
    return ALL_SHOWCASES.map((s) => s.name);
}
